export const userQuotaConverter = {
    toFirestore(quota) {
        const { id, ...data } = quota;
        return {
            ...data,
        };
    },
    fromFirestore(snapshot, options) {
        const data = snapshot.data(options);
        const entries = data?.entries ?? [];
        const normalizedEntries = Array.isArray(entries)
            ? entries.map((e) => ({
                value: typeof e.value === 'number' ? e.value : 0,
                changedAt: typeof e.changedAt === 'string' ? e.changedAt : new Date().toISOString(),
                changedBy: typeof e.changedBy === 'string' ? e.changedBy : '',
            }))
            : [];
        return {
            id: snapshot.id,
            userId: data?.userId ?? '',
            type: data?.type ?? 'inventory_trucks',
            entries: normalizedEntries,
        };
    },
};
